import { format } from "date-fns";

export default function formatPublishedDate(
  date: string,
  pattern: string = "dd MMM yyyy",
) {
  return date != "" ? format(new Date(date), pattern) : "";
}
